import type { StorageAdapter } from '../types';

function requireLocalStorage(): Storage {
	if (typeof localStorage === 'undefined') {
		throw new Error('localStorage is not available');
	}

	return localStorage;
}

/** Async wrapper over `window.localStorage` (rejects on quota / access errors). */
export function createLocalStorageAdapter(): StorageAdapter {
	return {
		async getItem(key: string): Promise<string | null> {
			return requireLocalStorage().getItem(key);
		},
		async setItem(key: string, value: string): Promise<void> {
			requireLocalStorage().setItem(key, value);
		},
		async removeItem(key: string): Promise<void> {
			requireLocalStorage().removeItem(key);
		},
		async clear(): Promise<void> {
			requireLocalStorage().clear();
		},
		async keys(): Promise<string[]> {
			const storage = requireLocalStorage();
			const out: string[] = [];
			for (let i = 0; i < storage.length; i++) {
				const key = storage.key(i);
				if (key !== null) {
					out.push(key);
				}
			}

			return out;
		},
	};
}
